import { render, staticRenderFns } from "./list_nav.vue?vue&type=template&id=5b0a233e"
import script from "./list_nav.vue?vue&type=script&lang=js"
export * from "./list_nav.vue?vue&type=script&lang=js"
import style0 from "./list_nav.vue?vue&type=style&index=0&id=5b0a233e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports